import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LazyLoadEvent, Table } from 'primeng';
import { IAccountCode } from '../../interfaces/account-code';
import { IAccountCodeFilter } from '../../interfaces/account-code-filter';
import { NoEmptyString } from '../../interfaces/no-empty-string.validator';
import { IPageResult } from '../../interfaces/page-result';
import { AccountCodeService } from '../../services';
import { MenuService } from '../../services';
import { Observable, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'account-codes',
  templateUrl: './manage-account-code.component.html',
})
export class AccountCodesComponent implements OnInit {
  public isNew = false;
  public backTo: string;

  public filter: Subject<IAccountCodeFilter>;
  public filterVal: IAccountCodeFilter;
  public first: number = 0;
  public page: IPageResult<IAccountCode> = {
    items: [],
    total: 0,
  };

  public pageTitle: string = '';
  public event: any;
  public filterString: string;
  public gridisLoaded: boolean = false;
  public isLoaded: boolean = false;
  public displayDialog: boolean = false;
  public accountCode: IAccountCode;
  public newAccountCode: boolean = false;
  public newAccountCodeForm: UntypedFormGroup;
  public name: UntypedFormControl;
  public code: UntypedFormControl;
  public isActive: UntypedFormControl;
  public selectedItem: any;

  //EditForm
  public editAccountCode: boolean = false;
  public currAccountCode: IAccountCode;
  public displayEditDialog: boolean = false;
  public currAccountCodeForm: UntypedFormGroup;
  public currname: UntypedFormControl;
  public currcode: UntypedFormControl;
  public currisActive: UntypedFormControl;

  public SelectedOrgId: any;

  constructor(
    private accountCodeService: AccountCodeService,
    private router: Router,
    private route: ActivatedRoute,
    public menuService: MenuService,
  ) {}

  ngOnInit() {
    this.backTo = this.route.snapshot.params['backTo'];

    this.initDefaultFilter();

    this.route.params.subscribe((params: Params) => {
      this.SelectedOrgId = params['id'];
    });
    console.log(this.SelectedOrgId);

    this.filter = new Subject<IAccountCodeFilter>();

    if (this.SelectedOrgId == undefined) {
      this.accountCodeService.getCurrentUserOrgId().then((res) => {
        this.SelectedOrgId = res;

        //Filtering
        // subscribe to filter changes with a debounce time
        this.filter.pipe(debounceTime(500)).subscribe((f) => {
          this.load(f);
          this.filterVal = f;
        });

        // set default filter
        this.filter.next(this.filterVal);
      });
    } else {
      //Filtering
      // subscribe to filter changes with a debounce time
      this.filter.pipe(debounceTime(500)).subscribe((f) => {
        this.load(f);
        this.filterVal = f;
      });

      // set default filter
      this.filter.next(this.filterVal);
    }

    this.name = new UntypedFormControl(
      '',
      Validators.compose([Validators.required, Validators.maxLength(50), NoEmptyString]),
    );
    this.code = new UntypedFormControl(
      '',
      Validators.compose([Validators.required, Validators.maxLength(20), NoEmptyString]),
    );
    this.isActive = new UntypedFormControl(true, Validators.required);

    this.currname = new UntypedFormControl('', Validators.required);
    this.currcode = new UntypedFormControl('', Validators.required);
    this.currisActive = new UntypedFormControl(true, Validators.required);

    this.newAccountCodeForm = new UntypedFormGroup({
      name: this.name,
      code: this.code,
      isActive: this.isActive,
    });

    this.currAccountCodeForm = new UntypedFormGroup({
      name: this.currname,
      code: this.currcode,
      isActive: this.currisActive,
    });

    this.isLoaded = true;
  }

  showEdit(currAccCode) {
    this.editAccountCode = true;
    this.currAccountCode = {
      id: currAccCode.id,
      name: currAccCode.name,
      code: currAccCode.code,
      isActive: currAccCode.isActive,
      organisationId: currAccCode.SelectedOrgId,
    };
    this.resetEditFormValues(this.currAccountCode);
    this.displayEditDialog = true;
  }

  resetEditFormValues(formValues) {
    this.currAccountCodeForm.setValue({
      name: formValues.name,
      code: formValues.code,
      isActive: formValues.isActive,
    });
  }

  showDialogToAdd() {
    this.isNew = true;
    this.newAccountCode = true;
    this.accountCode = {
      id: 0,
      name: '',
      code: '',
      isActive: true,
      organisationId: this.SelectedOrgId,
    };
    this.resetFormValues(this.accountCode);
    this.displayDialog = true;
  }

  resetFormValues(formValues) {
    this.newAccountCodeForm.setValue({
      name: formValues.name,
      code: formValues.code,
      isActive: formValues.isActive,
    });
  }

  save(formValues) {
    this.accountCode.name = formValues.name.trim();
    this.accountCode.code = formValues.code.trim();
    this.accountCode.isActive = formValues.isActive;
    if (this.accountCode.name !== '' && this.accountCode.code !== '') {
      this.accountCodeService.create(this.accountCode).then((res) => {
        this.load(this.filterVal);
      });
    }
    this.displayDialog = false;
  }

  dlgClose() {
    this.displayDialog = false;
  }

  edit(formValues) {
    console.log('edit');
    this.currAccountCode.name = formValues.name;
    this.currAccountCode.code = formValues.code;
    this.currAccountCode.isActive = formValues.isActive;
    this.accountCodeService.create(this.currAccountCode).then((res) => {
      this.load(this.filterVal);
    });
    this.displayEditDialog = false;
  }

  //Grid
  load(filter: IAccountCodeFilter) {
    //filter["filters.id.matchMode"] = "equals"
    filter['filters.id.value'] = this.SelectedOrgId;
    this.accountCodeService.getPage(filter).then((result) => {
      this.page.items = result.items;
      this.page.total = result.total;
      this.gridisLoaded = true;
    });
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    this.filterVal.first = event.first;
    this.filterVal.rows = event.rows;
    this.filterVal.sortField = event.sortField;
    this.filterVal.sortOrder = event.sortOrder;

    this.filter.next(this.filterVal);
  }

  onRowSelect(event) {
    this.event = event;
  }

  onRowDblclick(item) {
    this.isNew = false;
    this.newAccountCode = false;
    this.accountCode = this.cloneAccountCode(item);
    this.resetFormValues(this.accountCode);
    this.displayDialog = true;
  }

  onEdit() {
    if (this.event !== undefined) {
      this.onRowDblclick(this.event);
    }
  }

  cloneAccountCode(c: IAccountCode): IAccountCode {
    let accountCode = { id: 0, name: '', code: '', isActive: true };
    for (let prop in c) {
      accountCode[prop] = c[prop];
    }

    return accountCode;
  }

  backToOrg() {
    window.history.back();
  }

  initDefaultFilter() {
    this.filterVal = {
      first: 0,
      rows: 10,
      sortField: 'Name',
      sortOrder: 1,
      filters: {
        name: {},
        code: {},
        isActive: {},
        id: {},
      },
    };
  }

  clearFilter(dt: Table) {
    dt.sortField = '';
    dt.rows = 10;
    this.initDefaultFilter();
    this.filter.next(this.filterVal);
  }

  search() {
    this.filterVal.first = 0; //fix error - when you set page > 1 and filter, then data not display
    console.log(this.filterVal);
    this.filter.next(this.filterVal);
  }

  close() {
    this.router.navigate([this.backTo]);
  }
}
